import { Link } from "react-router-dom";
import MobileHeader from "../../components/MobileHeader";
import { ChevronRight } from "lucide-react";

const ALL_PRODUCTS = [
    { name: "NanoCredit", title: "NanoCredit™", subtitle: "Instant small loans", limit: "Up to ₦50,000", color: "#00D084", bg: "bg-emerald-50", text: "text-emerald-700", action: "Apply Now" },
    { name: "FlexCredit", title: "FlexCredit™", subtitle: "Revolving credit line", limit: "Up to ₦250,000", color: "#0066FF", bg: "bg-blue-50", text: "text-blue-700", action: "Access Now" },
    { name: "SalaryAdvance", title: "SalaryAdvance™", subtitle: "Access your salary early", limit: "Up to 50% of salary", color: "#FF6B00", bg: "bg-orange-50", text: "text-orange-700", action: "Apply Now" },
    { name: "SplitPay", title: "SplitPay™", subtitle: "Borrow together, build together", limit: "2 – 6 installments", color: "#7000FF", bg: "bg-purple-50", text: "text-purple-700", action: "Apply Now" },
    { name: "PrimeCredit", title: "PrimeCredit™", subtitle: "Larger loans, better rates", limit: "Up to ₦5,000,000", color: "#FF0055", bg: "bg-rose-50", text: "text-rose-700", action: "Apply Now" },
];

export default function CreditProducts() {
    return (
        <div data-testid="credit-products-page">
            <MobileHeader title="Credit Products" subtitle="Choose what works for you" backTo="/consumer" />
            <div className="px-5 -mt-6 space-y-3 pb-4">
                {ALL_PRODUCTS.map((p) => (
                    <Link
                        to={`/consumer/credit/${p.name}`}
                        key={p.name}
                        data-testid={`credit-product-${p.name}`}
                        className={`block ${p.bg} rounded-2xl p-4 border border-slate-200/60 tap-feedback`}
                    >
                        <div className="flex items-center justify-between gap-3">
                            <div className="flex items-center gap-3 min-w-0">
                                <div
                                    className={`size-11 rounded-xl flex items-center justify-center ${p.text} flex-shrink-0`}
                                    style={{ background: `${p.color}25` }}
                                >
                                    <span className="font-display font-bold">{p.title.slice(0, 1)}</span>
                                </div>
                                <div className="min-w-0">
                                    <div className={`font-display font-semibold ${p.text}`}>{p.title}</div>
                                    <div className="text-xs text-slate-500 truncate">{p.subtitle}</div>
                                    <div className="text-[11px] text-slate-400 mt-0.5">{p.limit}</div>
                                </div>
                            </div>
                            <div
                                className="text-xs font-bold text-white rounded-lg py-2 px-3 flex-shrink-0"
                                style={{ background: p.color }}
                            >
                                {p.action}
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
